import React , { Component } from 'react';

import {connect} from 'react-redux';
import {fetch_expertTeam} from '../../actions/recruitment/createExpertTeamAction';
import {fetch_workRequire} from '../../actions/recruitment/createWorkRequireAction';
import {fetch_contact_us} from '../../actions/contactUs/createContactUsAction';

import RecruitmentSty from './recruitment.module.css';
import {baseUrl} from '../../contants/index';
import {getFirmIntro} from '../Content/service';


// import gzhj_img1 from '../../images/gzhj_img1.png';
// import gzhj_img2 from '../../images/gzhj_img2.png';
// import gzhj_img3 from '../../images/gzhj_img3.png';
// import gzhj_img4 from '../../images/gzhj_img4.png';

import zwsx_icon from '../../images/zwsx_icon.png';
import tdjl_icon from '../../images/tdjl_icon.png';
import mstz_icon from '../../images/mstz_icon.png';
import rzly_icon from '../../images/rzly_icon.png';
import yplc_next_bg from '../../images/yplc_next_bg.png';
import {withRouter} from "react-router";

import map_index_icon from '../../images/map_index.png';



// const zjtdText='公司拥有良好、广泛的合作伙伴关系，目前已与中关村国家自主创新示范区管委会及北京各园区管委会、北京市高新技术产业服务中心、北京市孵育协会、北京市中小企业协会以及其他一些行业协会等服务机构建立了稳定、持久的互助合作关系；与京、津、冀、晋、鄂、湘、粤等一些大中型企业、各类科技型企业孵化器等建立了长期、稳固的互惠合作关系。良好合作关系与广泛的信息资源使得公司拥有一批资深专家为公司的业务开展及客户服务实时诊断、把脉；同时，公司内部健全的服务质量控制体系与内部管理监管系统使我们为客户提供的管理咨询服务更具实效性与科学性。多年从业经历使公司在资质申报、资金申报、财务咨询、税收筹划、管理咨询等方面积累了丰富的经验，在项目申报方面公司总体通过率达98%以上，部分项目申报（如高新技术企业）通过率100%，客户满意率达99%以上，在业内收获了诸多好评和赞誉。';

// const gzhjText='公司拥有良好、广泛的合作伙伴关系，目前已与中关村国家自主创新示范区管委会及北京各园区管委会、北京市高新技术产业服务中心、北京市孵育协会、北京市中小企业协会以及其他一些行业协会等服务机构建立了稳定、持久的互助合作关系；与京、津、冀、晋、鄂、湘、粤等一些大中型企业、各类科技型企业孵化器等建立了长期、稳固的互惠合作关系。良好合作关系与广泛的信息资源使得公司拥有一批资深专家为公司的业务开展及客户服务实时诊断、把脉；同时，公司内部健全的服务质量控制体系与内部管理监管系统使我们为客户提供的管理咨询服务更具实效性与科学性。多年从业经历使公司在资质申报、资金申报、财务咨询、税收筹划、管理咨询等方面积累了丰富的经验，在项目申报方面公司总体通过率达98%以上，部分项目申报（如高新技术企业）通过率100%，客户满意率达99%以上，在业内收获了诸多好评和赞誉。';

// const gzhjImgListData=[
//     {key:0,img:gzhj_img1},
//     {key:1,img:gzhj_img2},
//     {key:2,img:gzhj_img3},
//     {key:3,img:gzhj_img4},
// ];

// const jobTypeData=[
//     {key:0,title:'项目经理（财税）1'},
//     {key:1,title:'项目经理（财税）2'},
//     {key:2,title:'项目经理（财税）3'},
//     {key:3,title:'项目经理（财税）4'},
//     {key:4,title:'项目经理（财税）5'},
//     {key:5,title:'项目经理（财税）6'},
// ];


// const gwzz='1.在副总经理的领导下，全面做好部门工作的计划、组织、协调、指导、跟进、品控及团队建设工作； 2.根据公司的总体安排和规划，做好公司客户及老客户的项目安排和服务维护，确保项目高效合规落地； 3.指导和监督业务部对各类项目材料的撰写以及补充完善，确保专业、准确无误； 4.组织业务部对各项目政策进行收集和研究，定期对部属进行政策及业务培训与考核； 5.对实施的业务项目进行全程监管和督导，发现问题及时提出解决方案并上报副总经理批准。加强品控工作，不断提高员工对项目的交付和风险防范能力； 6.在项目前期，参与市场部与客户的接洽及项目方案的撰写； 7.做好部门员工的文化建设与提升； 8.建立科学的保密管理机制，对客户信息、技术资料、财务状况等进行严格保密，对公司的项目文案及项目逻辑等进行保密； 9.协助市场部做好项目回款工作； 10.负责带领团队客户维护及深入的市场开发工作； 11.完成公司领导交办的其它工作。 ';

const yplcListData=[
    {key:0,title:'职位筛选',icon:zwsx_icon},
    {key:1,title:'next',icon:yplc_next_bg},
    {key:2,title:'投递简历',icon:tdjl_icon},
    {key:3,title:'next',icon:yplc_next_bg},
    {key:4,title:'等待面试通知',icon:mstz_icon},
    {key:5,title:'next',icon:yplc_next_bg},
    {key:6,title:'入职录用',icon:rzly_icon},
];

const ygZYSXData=[
    {key:0,title:'A：新员工未报到之前 ',content:['1．确认新员工报到日期及意向部门；','2．通知新员工在报到之前来公司明确报到需注意事项，所需资料件及复印件','3．行政部门准备好新员工入职手续办理所需表单、协议导师人选。','4．商定薪资。']},
    {key:1,title:'B：新员工正式报到',content:['1．提交所需资料；','2．新员工编号，填写新员工入职的一系列表单；','3．制作并开通新员工工牌，更新员工花名册；','4．确定宿舍房间及床号；','5．带新员工到其所在部门，介绍给其直接领导；','6．将新员工入职情况通过公司短信向全公司公告；','7．根据需求将新员工加入集团通讯录。 ']},
    {key:2,title:'C：员工所在部门办理 ',content:['1．部门直接领导为其入职引导，带领参观部门，介绍部门情况、部门人员；','2．介绍导师，签订《导师协议》；','3．由导师向新员工介绍其岗位职责与工作说明。']},
    {key:3,title:'D：新员工入职培训',content:['1．内容包括公司介绍、企业发展历程、企业文化与理念、各项制度等。','2．在导师的帮助指导下进行技术培训；','3．应在每周的例会上向大家介绍新入职员工并表示欢迎。']},
    {key:4,title:'E：新员工试用期',content:['1．部门直接领导跟进，进行面谈；','2．导师、部门直接领导进行员工试用期评估。']},
    {key:5,title:'F：转正评估',content:['根据导师意见，部门直接领导、总经理进行转正评估，若通过报行政部登记确认。']},
];

const applyWay_mail=['<p>',
'    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 20px;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 10px;"></span></span></strong></span>',
'</p>',
'<p>',
'    <strong style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 20px;">邮件申请：</strong>',
'</p>',
'<p style="line-height: 2em;">',
'    &nbsp;<span style="font-size: 18px;">&nbsp;&nbsp;&nbsp; <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">1.1您可以将简历发至经纬人才邮箱：</span><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; text-decoration: underline; color: rgb(0, 176, 240);">Jwtd_hr@163.com</span></span>',
'</p>',
'<p style="line-height: 2em;">',
'    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">&nbsp; &nbsp; &nbsp;1.2随时关注邮件回复</span>',
'</p>',
'<p style="line-height: 2em;">',
'    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">&nbsp; &nbsp; &nbsp;1.3参加面试时请携带本人相关证件原件，并注意着装职业</span>',
'</p>',
'<p style="line-height: 2em;">',
'    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">&nbsp; &nbsp; &nbsp;1.4公司支持在线远程视频面试</span>',
'</p>'].join("");

/*
<p>
    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 20px;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 10px;"></span></span></strong></span>
</p>
<p>
    <strong style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 20px;">邮件申请：</strong>
</p>
<p style="line-height: 2em;">
    &nbsp;<span style="font-size: 18px;">&nbsp;&nbsp;&nbsp; <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">1.1您可以将简历发至经纬人才邮箱：</span><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; text-decoration: underline; color: rgb(0, 176, 240);">Jwtd_hr@163.com</span></span>
</p>
<p style="line-height: 2em;">
    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">&nbsp; &nbsp; &nbsp;1.2随时关注邮件回复</span>
</p>
<p style="line-height: 2em;">
    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">&nbsp; &nbsp; &nbsp;1.3参加面试时请携带本人相关证件原件，并注意着装职业</span>
</p>
<p style="line-height: 2em;">
    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">&nbsp; &nbsp; &nbsp;1.4公司支持在线远程视频面试</span>
</p>
*/

const applyWay_phone=['<p>',
'    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 20px;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 10px;"></span></span></strong></span>',
'</p>',
'<p>',
'    <strong style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 20px;">电话申请：</strong>',
'</p>',
'<p style="line-height: 2em; text-align: justify;">',
'    &nbsp;<span style="font-size: 18px;">&nbsp;&nbsp;&nbsp; <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">2.1您可以直接致电进行相关职位的咨询和沟通，择机与面试官建立联系并发传简历，请及时查收面试通知</span></span>',
'</p>',
'<p style="line-height: 2em; text-align: justify;">',
'    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">&nbsp; &nbsp; &nbsp;2.2参加面试时请携带本人相关证件原件，并<span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">注意着装职业</span></span>',
'</p>',
'<p style="line-height: 2em; text-align: justify;">',
'    <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">&nbsp; &nbsp; &nbsp;2.3<span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">公司支持在线远程视频面试</span></span>',
'</p>'].join("");


class Recruitment extends Component{

    state={
        currentJobIndex:1, //当前选择的职位索引,默认选中第一个
        currentJobDuty:'', //当前选中职位的职责
        currentJobRequirement:'', //当前选中职位的要求
        jobShowMaxCount:4, //上方的列表最多可显示的职位数量
        jobShowList:[],  //上方显示的职位列表
        jobDuty:[],//职位列表对应的岗位职责，
        jobRequire:[], //职位列表对应的岗位要求
        jobIndexBtnList:[],  //职位索引按钮列表
        jobCount:4,  //总的职位数量
        jobIndexBtnMaxCount:5, //下方的职位索引按钮列，最多显示的按钮数量



        gzhjImgListData:[], //工作环境图片列表
        firm_data:[], //公司数据
        jobMailApplyWay:null,   //职位邮件申请方式
        jobPhoneApplyWay:null, // 职位电话申请方式
    }

    constructor(props){
        super(props);
        this.getJobBtnIndexList=this.getJobBtnIndexList.bind(this);
        this.getJobShowList=this.getJobShowList.bind(this);
        this.onSelectJobClick=this.onSelectJobClick.bind(this);
        this.preBtnOnClick=this.preBtnOnClick.bind(this);
        this.nextBtnOnClick=this.nextBtnOnClick.bind(this);
        this.initMap=this.initMap.bind(this);
    }

    async componentDidMount(){
        this.props.fetch_expertTeam('get',null);
        this.props.fetch_workRequire('get',null);
        this.props.fetch_contact_us('get',null);
        this.initMap();
        const {data}=await getFirmIntro();
        data.list.map((item,index)=>{
            if(item.id === 15 && item.title === "招聘设置-邮件申请")
                this.setState({jobMailApplyWay:item.value});
            if(item.id === 16 && item.title === "招聘设置-电话申请")
            this.setState({jobPhoneApplyWay:item.value});
        });
    }

    componentWillMount=()=>{

    }

    componentWillReceiveProps=({ history })=>{
        if (history.location.hash) {
            let anchor_contact_us=document.getElementById(history.location.hash);
            if(anchor_contact_us){
                anchor_contact_us.scrollIntoView();
            }
        }

        (async ()=>{
            await this.setState({
                gzhjImgListData:this.props.expert_team_data.work_cover,
                jobCount:this.props.work_require_data.length,
            })

            await this.setState({
                jobIndexBtnList:this.getJobBtnIndexList(this.state.currentJobIndex),
                jobShowList:this.getJobShowList(),
            })

            await this.setState({
                currentJobDuty:this.state.jobShowList[this.state.currentJobIndex-1]==undefined?null:this.state.jobShowList[this.state.currentJobIndex-1].jobDuty,
                currentJobRequirement:this.state.jobShowList[this.state.currentJobIndex-1]==undefined?null:this.state.jobShowList[this.state.currentJobIndex-1].jobRequirment,
            })
        })();

        this.setState({
            firm_data:this.props.firm_data,
        });
    }

    getJobShowList=()=>{
        let jobShowList=[];
        if(this.props.work_require_data!=undefined){
            this.props.work_require_data.map(({id,name,duty,requirement},index)=>{
                let obj={key:index,id:id,jobName:name,jobDuty:duty,jobRequirment:requirement}
                jobShowList.push(obj);
            });
        }

        return jobShowList;
    }


    // 动态生成职位索引按钮列表
    getJobBtnIndexList=(currentIndex)=>{
        // 注意，传进来的currentIndex的索引是从1开始的
        let tempIndexList=[];
        let jobCount=this.props.work_require_data.length;

        // 第一种情况，总职位数小于设定的最大职位索引按钮数量，直接按顺序放入即可
        if(jobCount <= this.state.jobIndexBtnMaxCount){
            for(let i=1;i<=jobCount;i++)
                tempIndexList.push(i);
        }else if(currentIndex == 1){
            //点击到第一个职位了
            for(let i=1;i<=this.state.jobIndexBtnMaxCount;i++)
                tempIndexList.push(i);
        }else if(currentIndex == jobCount){
            //点击到了最后一个职位
            let index=currentIndex;
            for (let i=1;i<=this.state.jobIndexBtnMaxCount && index > 0;i++,index--)
                tempIndexList.push(index);
            tempIndexList.reverse();
        }else{
            let index=currentIndex;

            if(currentIndex > this.state.jobIndexBtnList[this.state.jobIndexBtnMaxCount-1]){
                for(let i=0;i<this.state.jobIndexBtnMaxCount && index<=jobCount;i++,index++){
                    tempIndexList.push(index);
                }
            }else{
                for(let i=0;i<this.state.jobIndexBtnMaxCount && index >0;i++,index--)
                    tempIndexList.push(index);
                tempIndexList.reverse();
            }


            // if(currentIndex==this.state.jobIndexBtnList[0]){
            //     // 如果点击了当前按钮索引列表的第一个职位的索引按钮

            // }else{
            //     // 如果点击了当前按钮索引列表的最后一个职位的索引按钮
            //     for(let i=0;i<this.state.jobIndexBtnMaxCount && index<=jobCount;i++,index++){
            //         tempIndexList.push(index);
            //     }

            //     // if (index<this.state.pageCount-1){
            //     //     tempIndexList.push('...');
            //     //     tempIndexList.push(this.state.pageCount);
            //     // }else{
            //     //     tempIndexList.push(index);
            //     //     tempIndexList.push(index+1);
            //     // }
            // }

        }
        return tempIndexList;
    }

    // 按钮选择职位的响应事件
    onSelectJobClick=(currentIndex)=>{
        // 注意，这里传入的currentIndex的索引是从1开始的
        // console.log('当前按钮是:'+currentIndex);
        //当用户只点击索引按钮时，不更新索引列表

        //更新职位职责和要求
        this.setState({
            currentJobIndex:currentIndex,
            currentJobDuty:this.state.jobShowList[currentIndex-1]==undefined?null:this.state.jobShowList[currentIndex-1].jobDuty,
            currentJobRequirement:this.state.jobShowList[currentIndex-1]==undefined?null:this.state.jobShowList[currentIndex-1].jobRequirment,
        })

    }

    preBtnOnClick=()=>{
        let currentIndex=this.state.currentJobIndex==1?1:this.state.currentJobIndex-1;

        //当点击向前选择时，若索引小于当前按钮索引列表的第一个，就更新列表
        if(currentIndex<this.state.jobIndexBtnList[0]){
            this.setState({
                currentJobIndex:currentIndex,
                jobIndexBtnList:this.getJobBtnIndexList(currentIndex),
            });
        }else{
            this.setState({
                currentJobIndex:currentIndex,
            });
        }

        //更新当前职位的职责和要求
        this.setState({
            currentJobDuty:this.state.jobShowList[currentIndex-1]==undefined?null:this.state.jobShowList[currentIndex-1].jobDuty,
            currentJobRequirement:this.state.jobShowList[currentIndex-1]==undefined?null:this.state.jobShowList[currentIndex-1].jobRequirment,
        });
    }

    nextBtnOnClick=()=>{
        let currentIndex=this.state.currentJobIndex==this.state.jobCount?this.state.jobCount:this.state.currentJobIndex+1;

        //当点击下一个职位，索引已经超出当前按钮索引列表最后一个索引时，就更新列表
        if(currentIndex>this.state.jobIndexBtnList[this.state.jobIndexBtnMaxCount-1]){
            this.setState({
                currentJobIndex:currentIndex,
                jobIndexBtnList:this.getJobBtnIndexList(currentIndex),
            });
        }else{
            this.setState({
                currentJobIndex:currentIndex,
            });
        }

        //更新当前职位的职责和要求
        this.setState({
            currentJobDuty:this.state.jobShowList[currentIndex-1]==undefined?null:this.state.jobShowList[currentIndex-1].jobDuty,
            currentJobRequirement:this.state.jobShowList[currentIndex-1]==undefined?null:this.state.jobShowList[currentIndex-1].jobRequirment,
        });
    }

    // 岗位名称列表的item点击响事件
    onJobShowListItemClick=(index)=>{
        this.onSelectJobClick(index);
    }


    // 初始化地图
    initMap=()=>{
        var qq = window.qq;
        var firmLoc=new qq.maps.LatLng(39.937165,116.19758);
        var map = new qq.maps.Map(document.getElementById("locationMap"), {
            // 地图的中心地理坐标。
            // 第一个参数是纬度，第二个是经度
            center: firmLoc,
            zoom: 15, //地图缩放级别
            draggableCursor : 'https://mapapi.qq.com/web/lbs/javascriptV2/demo/img/c1.cur',     //设置鼠标拖拽元素样式
            draggingCursor : 'https://mapapi.qq.com/web/lbs/javascriptV2/demo/img/c2.cur',
            mapTypeId: qq.maps.MapTypeId.ROADMAP,      //设置鼠标移动样式
        });
        var marker = new qq.maps.Marker({
            position: firmLoc,
            map: map
        });
        marker.setIcon(map_index_icon);


    }

    render(){
        // console.log('招贤纳士查看props')
        // console.log(this.props)

        // console.log('招贤纳士查看state')
        // console.log(this.state)

        let gzhjImgListData2=[];
        let post_code=this.props.firm_data[8]!=undefined?this.props.firm_data[8].value:null;
        let phone=this.props.firm_data[5]!=undefined?this.props.firm_data[5].value:null;
        let fax=this.props.firm_data[6]!=undefined?this.props.firm_data[6].value:null;

        let firm_address=this.props.firm_data[9]!=undefined?JSON.parse(this.props.firm_data[9].value).address:null;


        if(this.props.expert_team_data.work_cover != undefined){
            for(let i=0;i<this.props.expert_team_data.work_cover.length;i++){
                let obj={key:i,imgSrc:this.props.expert_team_data.work_cover[i]};
                gzhjImgListData2.push(obj);
            }
        }
        // this.props.expert_team_data.work_cover.forEach((imgSrc,index,arr) => {
        //     let obj={key:index,imgSrc:imgSrc};
        //     gzhjImgListData2.push(obj);
        // });
        let gzhjImgLis=gzhjImgListData2.map(({key,imgSrc})=>{
            return(
                <li key={key}>
                    <div className={RecruitmentSty.gzhj_li_imgSty} style={{backgroundImage:`url(${baseUrl+imgSrc})`}}></div>
                </li>
            );
        });

        let jobShowList=[];
        if(this.props.work_require_data!=undefined){
            this.props.work_require_data.map(({id,name,duty,requirement},index)=>{
                let obj={key:index,id:id,jobName:name,jobDuty:duty,jobRequirment:requirement}
                jobShowList.push(obj);
            });
        }

        // jobTypeData
        let jobLis=jobShowList.map(({key,jobName,jobDuty,jonRequirement},index)=>{
            // console.log('当前的key是'+key)
            let itemSelectedSty={
                backgroundColor:'#181818',
                color:'#FFFFFF',
                fontWeight:'bold',
                fontFamily:'Microsoft YaHei',
            }
            let itemNormalSty={
                backgroundColor:'#EEEEEE',
                color:'#333333',
            }
            let jobShowListIndex=this.state.currentJobIndex-1;

            // if(key<this.state.jobShowMaxCount){
            //     return (
            //         <li key={key}>
            //             <div>{jobName}</div>
            //         </li>
            //     );
            // }else{
                //当key超过jobShowMaxCount的时候，考虑用户选择的当前职位索引位置在哪
                let allScopeIndex=Math.abs(key-jobShowListIndex);
                    if(allScopeIndex<this.state.jobShowMaxCount && key >= jobShowListIndex-3){
                        //如果这个key的位置跟用户点击的索引位置在最大允许的显示范围内，就显示它
                        return (
                            <li key={key} style={this.state.currentJobIndex-1==key?itemSelectedSty:itemNormalSty} onClick={()=>{this.onJobShowListItemClick(index+1)}}>
                                <div>{jobName}</div>
                            </li>
                        )
                    }
            // }
            return null;

        });


        // let jobIndexBtnLis=this.state.jobIndexBtnList.map((value)=>{
        //     // value的值索引应该是从1开始的
        //     let btnSelectedSty={
        //         backgroundColor:'#000000',
        //         color:'#ffffff'
        //     }
        //     let btnNormalSty={
        //         backgroundColor:'#CCCCCC',
        //         color:'#000000'
        //     }
        //     return (
        //         <li
        //            key={value}
        //            onClick={()=>{this.onSelectJobClick(value)}}
        //            style={this.state.currentJobIndex==value?btnSelectedSty:btnNormalSty}
        //         >{value}</li>
        //     );
        // });


        return(
            <div>
                <div className={RecruitmentSty.contentSty}>


                    <div className={RecruitmentSty.contentDiv}>
                        <div className={RecruitmentSty.titleSty}>欢迎加入经纬通达</div>


                        <div className={RecruitmentSty.articleDiv}>
                            {/* 经纬通达专家团队 */}
                            {/* <div className={RecruitmentSty.zjtdDiv}>
                                <div dangerouslySetInnerHTML={{__html:this.props.expert_team_data.term}}>

                                </div>
                                <div className={RecruitmentSty.zjtdImgSty} style={{backgroundImage:`url(${baseUrl+this.props.expert_team_data.term_cover})`}}></div>
                            </div> */}


                            {/* 工作环境 */}
                            {/* <div className={RecruitmentSty.gzhjDiv}>
                                <div dangerouslySetInnerHTML={{__html:this.props.expert_team_data.work}}>
                                </div>
                                <ul>
                                    {gzhjImgLis}
                                </ul>
                            </div> */}


                            {/* 岗位要求+应聘方式 */}
                            <div className={RecruitmentSty.gwyqDiv}>
                                {/* <div className={RecruitmentSty.gwyqTitleSty}>岗位要求</div> */}

                                <ul className={RecruitmentSty.job_ul_sty}>
                                    {jobLis}
                                </ul>

                                {/* 分割线 */}
                                <div  className={RecruitmentSty.job_split_sty}></div>


                                {/* 岗位具体要求 */}
                                <div className={RecruitmentSty.job_requirement_div}>
                                    <div className={RecruitmentSty.job_duty_div} dangerouslySetInnerHTML={{__html:this.state.currentJobDuty+this.state.currentJobRequirement}}>

                                    </div>
                                    {/* <div className={RecruitmentSty.job_require_div} dangerouslySetInnerHTML={{__html:this.state.currentJobRequirement}}>

                                    </div> */}
                                </div>

                                {/* 岗位申请方式 */}
                                <div className={RecruitmentSty.job_apply_way_div}>
                                    <div className={RecruitmentSty.job_apply_mail_div} dangerouslySetInnerHTML={{__html:this.state.jobMailApplyWay}}>
                                        
                                    </div>
                                    <div className={RecruitmentSty.job_apply_phone_div} dangerouslySetInnerHTML={{__html:this.state.jobPhoneApplyWay}}>

                                    </div>
                                </div>


                                {/* 岗位要求下方职位编索引按钮列表 */}
                                {/* <div className={RecruitmentSty.job_btn_div}>
                                    <div className={RecruitmentSty.preBtnSty} onClick={this.preBtnOnClick}></div>
                                    <ul style={{marginBottom:0}}>
                                       {jobIndexBtnLis}
                                    </ul>
                                    <div className={RecruitmentSty.nextBtnSty} onClick={this.nextBtnOnClick}></div>
                                </div> */}

                                {/* 应聘方式 */}
                                {/* <div className={RecruitmentSty.ypfsDiv}>
                                    <div className={RecruitmentSty.ypfs_titleSty}>应聘方式</div>
                                    <ul>
                                    {
                                        yplcListData.map(({key,title,icon}, index)=>{
                                            let res= title==='next'?(
                                                <li key={index}>
                                                     <div className={RecruitmentSty.yplc_next_iconSty} style={{backgroundImage:`url(${icon})`}}></div>
                                                </li>

                                            ):(
                                                <li key={index}>
                                                    <div className={RecruitmentSty.yplc_iconSty} style={{backgroundImage:`url(${icon})`}}></div>
                                                    <div className={RecruitmentSty.yplc_textSty}>{title}</div>
                                                </li>
                                            );
                                            return res;

                                        })
                                    }
                                    </ul>
                                </div> */}

                            </div>


                            {/* 新员工注意事项 */}
                            {/* <div className={RecruitmentSty.zysxDiv}>
                                <div className={RecruitmentSty.zysx_titleSty}>新员工注意事项</div>
                                <ul>
                                    {
                                        ygZYSXData.map(({key,title,content}, index)=>{

                                            let conSpans=content.map((item, _index)=>{
                                                return (
                                                    <p key={_index}>{item}</p>
                                                )
                                            });

                                            return(
                                                <li key={index}>
                                                    <span className={RecruitmentSty.zysxTitleSpanSty}>{title}</span>
                                                    <div className={RecruitmentSty.zysxContentSty}>{conSpans}</div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div> */}

                            <div style={{width: '100%',height: 10}}>
                                <a id="#contact-us"></a>
                            </div>

                            {/* 联系我们 */}
                            <div className={RecruitmentSty.lxwmDiv}>
                                
                                <div className={RecruitmentSty.lxwmTtileSty}>联系我们</div>
                                <div className={RecruitmentSty.lxwm_info_div}>
                                    <div>邮编：{post_code}</div>
                                    <div>电话：{phone}</div>
                                    <div>传真：{fax}</div>
                                    <div>地址：{firm_address}</div>
                                </div>

                                <div className={RecruitmentSty.mapDivSty}>
                                    {/* <iframe id="locationMap" width="100%" height="100%" frameborder="0" scrolling="0"
                                        src="https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:39.96554,116.26719;title:成都;addr:北京市海淀区复兴路32号院|coord:39.87803,116.19025;title:成都园;addr:北京市丰台区射击场路15号北京园博园|coord:39.88129,116.27062;title:老成都;addr:北京市丰台区岳各庄梅市口路西府景园六号楼底商|coord:39.9982,116.19015;title:北京园博园成都园;addr:北京市丰台区园博园内&key=6WPBZ-TPC6G-DJCQX-I4NNX-O26YZ-63B7X&referer=经纬通达-前端位置展示"
                                    
                                    >

                                    </iframe> */}
                                    <div id="locationMap" style={{width: '100%', height:'100%'}}>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        );

    }
}

const mapStateToProps=(state)=>{
    return {
        expert_team_data:state.jwRecruitmentReducer.expert_team_data,
        work_require_data:state.jwRecruitmentReducer.work_require_data,
        firm_data:state.contactUsReducer.firm_data,
    }
}

const mapDispatchToProps=(dispatch)=>{
    return{
        fetch_expertTeam:(method,params)=>{dispatch(fetch_expertTeam(method,params))},
        fetch_workRequire:(method,params)=>{dispatch(fetch_workRequire(method,params))},
        fetch_contact_us:(method,params)=>{dispatch(fetch_contact_us(method,params))},
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Recruitment));
